import gsap, { mapRange, clamp } from 'gsap/all'
import { module } from 'modujs'

export default class extends module {
    constructor(m) {
        super(m)

        // Binding
        this.onResizeBind = this.onResize.bind(this)
        this.onFontsLoadedBind = this.onFontsLoaded.bind(this)

        // UI
        this.$el = this.el
        this.$video = this.$('video')[0]

        this.$default = this.$('default')[0]
        this.$media = this.$('media')[0]
        this.$mediaInner = this.$('mediaInner')[0]
        this.$mediaContent = this.$('mediaContent')[0]
        this.$button = this.$('button')[0]

        // Data
        this.offsetX = 0
        this.offsetY = 0
        this.scale = 1
        this.progress = 0
        this.progressThreshold = .75

        // Flag
        this.isFirstInit = false
        this.isRevealed = false
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        if (!window.isSmooth) {
            return
        }

        this.bindEvents()

        if (window.isFontsLoaded) {
            this.onFontsLoaded()
        }
    }

    destroy() {
        super.destroy()
        this.unbindEvents()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        window.addEventListener("resizeEnd", this.onResizeBind)
        window.addEventListener("fontsLoaded", this.onFontsLoadedBind)
    }

    unbindEvents() {
        window.removeEventListener("resizeEnd", this.onResizeBind)
        window.removeEventListener("fontsLoaded", this.onFontsLoadedBind)
    }

    ///////////////
    // Callbacks
    ///////////////
    onResize() {
        this.resize()
    }

    onFontsLoaded() {
        this.resize()
    }

    onProgress(progress) {
        this.progress = clamp(0, 1, mapRange(0, this.progressThreshold, 0, 1, progress))
        this.timeline && this.timeline.progress(this.progress)

        if (this.progress >= .99 && !this.isRevealed) {
            this.isRevealed = true
            this.$el.classList.add('is-revealed')
        } else if (this.progress < .99 && this.isRevealed) {
            this.isRevealed = false
            this.$el.classList.remove('is-revealed')
        }
    }

    onEnter() {
        this.playVideo()
    }

    onLeave() {
        this.pauseVideo()
    }

    ///////////////
    // Methods
    ///////////////
    resize() {
        // Data
        this.computeMetrics()

        // Timeline
        this.setTimeline()

        // Progress
        this.timeline && this.timeline.progress(this.progress)
    }

    playVideo() {
        this.$video && this.$video.play()
    }

    pauseVideo() {
        this.$video && this.$video.pause()
    }

    computeMetrics() {
        const defaultBCR = this.$default.getBoundingClientRect()
        const mediaBCR = this.$media.getBoundingClientRect()
        const scale = this.scale = defaultBCR.width / mediaBCR.width
        const paddingBottom = getComputedStyle(this.$mediaContent).getPropertyValue('padding-bottom').replace("px", "")
        
        this.offsetX = defaultBCR.left - window.innerWidth * .5 + (mediaBCR.width * scale * .5);
        this.offsetY = (window.innerHeight - paddingBottom - defaultBCR.height) - window.innerHeight * .5 + (mediaBCR.height * scale * .5);
    }



    setTimeline() {
        if (this.timeline) {
            // kill the timeline
            this.timeline.kill();
            // set to null so the reference is removed
            this.timeline = null;
        }

        this.timeline = gsap.timeline({
            paused: true
        })

        this.timeline.fromTo(
            [this.$mediaInner, this.$button], {
                x: `${this.offsetX}`,
                y: `${this.offsetY}`
            }, {
                x: 0,
                y: 0,
                duration: .4,
                ease: 'none'
            }, 0)
            
        this.timeline.fromTo(
            [this.$mediaInner, this.$button], {
                scale: `${this.scale}`,
            }, {
                scale: 1,
                duration: .6,
                ease: 'none'
            }, .4)
    }
}